import React, {useState, useEffect} from 'react'
import Button from '@mui/material/Button';
import { useDispatch, useSelector } from 'react-redux';
import * as XLSX from "xlsx-color";
import { IconButton, Tooltip } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

const ExportToExcel = () => {

    const selectedWeeks = useSelector(state => state.chooseWeek.value)
    const selectedItems = useSelector(state => state.chooseItem.value)
    const dateData = useSelector(state => state.dateData.value)
    const chartData = useSelector(state => state.chartData.value)
    const stockData = useSelector(state => state.rawData)

    const [moreThanOneSelectedItem, setMoreThanOneSelectedItem] = useState(false)
    
    useEffect(() => {

        // setMoreThanOneSelectedItem(false)
        let temp = false

        for (const [groupKey, groupValue] of Object.entries(selectedItems)) {
            for (const [key, value] of Object.entries(groupValue)) {
                if (temp == true){
                    setMoreThanOneSelectedItem(true)
                    return}
                    temp = value
            }
        }
        setMoreThanOneSelectedItem(temp)
    }, [selectedItems])


    const dispatch = useDispatch()

    const makeExcelData = () => {
        const temp = []
        // Filter for the selected weeks
        dateData.forEach(project => {
            const projectDate = new Date(project.datum).getTime()
            if (projectDate > selectedWeeks.from && projectDate < selectedWeeks.to) {
                temp.push({...project, voorraadNaProject: 0})
            }
        })
        // filter for the selected items
        const temp2 = []

        temp.forEach(project => {
            for (const [groupKey, groupValue] of Object.entries(selectedItems)) {
                for (const [key, value] of Object.entries(groupValue)) {
                    if (key === project.tariefomschrijving && value) {
                        temp2.push(project)
                    }
                }
            }
        })


        temp2.forEach(project => {
            chartData.forEach(date => {
                const tempProjectDate = new Date(project.datum)
                tempProjectDate.setHours(0,0,0,0)
                const projectDate = tempProjectDate.getTime()
                const itemDate = date.date

                if (projectDate == itemDate){
                    for (const [key, value] of Object.entries(date)) {
                        if (key === project.tariefomschrijving) {
                            project.voorraadNaProject = value
                        }
                    }
                }
            })
        })

        // sort temp2 by date
        temp2.sort((a, b) => {
            const dateA = new Date(a.datum)
            const dateB = new Date(b.datum)
            return dateA - dateB
        })


        return temp2
    }

    const makeFileTitle = () => {
        const today = new Date
        today.setHours(0,0,0,0)
        const title = `data export - ${today.getDate()}-${today.getMonth()}-${today.getFullYear()}`
        return title
    }
        


    const downloadExcel = (data) => {
        const title = makeFileTitle()
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");


        for (const [key, value] of Object.entries(workbook.Sheets.Sheet1)) {
            if (key[0] === "F" && value.v !== "voorraadNaProject") {
                if (value.v < 0) {
                    workbook.Sheets.Sheet1[key].s = {fill: {fgColor: {rgb: "FF0000"}, bgColor: {rgb: "FF0000"}, patternType: "solid"}};
                } else if (value.v == 0) {
                    workbook.Sheets.Sheet1[key].s = {fill: {fgColor: {rgb: "FFA500"}, bgColor: {rgb: "FFA500"}, patternType: "solid"}};
                } else {
                    workbook.Sheets.Sheet1[key].s = {fill: {fgColor: {rgb: "00FF00"}, bgColor: {rgb: "00FF00"}, patternType: "solid"}}
                }
            }
        }
        
        XLSX.writeFile(workbook, `${title}.xlsx`);
      };


  return (
    <IconButton
        sx={{margin: "10px"}}
        onClick={() => downloadExcel(makeExcelData())}
        {...(moreThanOneSelectedItem ? {disabled: false} : {disabled: true})}
    >
        <Tooltip title="Exporteer naar Excel" arrow>
            <FileDownloadIcon />
        </Tooltip>
    </IconButton>

  )
}

export default ExportToExcel